import { CompartilhadoUsuarioService } from '../services/compartilhado/compartilhado-usuario.service';
import {
  HttpInterceptor,
  HttpHandler,
  HttpEvent,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CompartilhadoContadorHttpService } from '../services/compartilhado/compartilhado-contador-http.service';
import { catchError, map } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ERRO_NAO_INTERROMPE_NAVEGACAO, TRATAR_ERRO_NO_COMPONENTE } from './http-context.tokens';

@Injectable()
export class InterceptorHttp implements HttpInterceptor {

  constructor(
    private _toastr: ToastrService,
    private router: Router,
    private _compartilhadoContadorHttpService: CompartilhadoContadorHttpService,
    private _compartilhadoUsuarioService: CompartilhadoUsuarioService) {

    this._compartilhadoContadorHttpService = CompartilhadoContadorHttpService.obterInstancia();
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const usuarioLogado = this._compartilhadoUsuarioService.obterUsuarioLogado();

    const requisicao = usuarioLogado
      ? request.clone({
          headers: request.headers
            .set('APP_ID', `backoffice`)
            .set('authorization', `bearer ${usuarioLogado.token}`)
            .set('usuarioId', `${usuarioLogado.id}`)
        })
      : request;

    const delegarAoComponente = request.context.get(TRATAR_ERRO_NO_COMPONENTE);
    const naoInterromper = request.context.get(ERRO_NAO_INTERROMPE_NAVEGACAO);

    return next
      .handle(requisicao)
      .pipe(catchError((err: any) => this.tratarErro(err, delegarAoComponente, naoInterromper)));
  }

  /** Ver http-context.tokens.ts para o significado de cada marcação da requisição. */
  private tratarErro(err: any, delegarAoComponente: boolean, naoInterromper: boolean): Observable<never> {
    this._compartilhadoContadorHttpService.subtrairDoContador();

    if (delegarAoComponente) {
      return throwError(err);
    }

    // Requisição acessória: engole tudo que não seja 401 sem navegar; o 401 segue
    // o fluxo normal (sessão expirada vai para o login venha de onde vier).
    if (naoInterromper && err instanceof HttpErrorResponse && err.status !== 401) {
      return EMPTY;
    }

    if (err instanceof HttpErrorResponse && !this.validaErrorResponse(err)) {
      return throwError(err);
    }

    return EMPTY;
  }

  validaErrorResponse(err) {
    if (err.status === 401) {
      localStorage.clear();
      this.router.navigate(['/login']);
      return true;
    }

    if (err.status === 404) {
      this.router.navigate(['/pagina-nao-encontrada']);
      return true;
    }
    if (err.status === 0 || err.status === 12002 || err.status === 12152) {
      // this._toastr.error('Não foi possível concluir sua operação, verifique sua conexão com a internet');
      // this.router.navigate(['/login']);
      return false;
    }
    if (err.status === 500) {
      this.router.navigate(['/pagina-em-manutencao']);
      return true;
    }

    if (err.status === 403) {
      this.router.navigate(['/pagina-acesso-negado']);
      return true;
    }

    return false;
  }
  excluirRota(url: string): boolean {

    let rotas = [
      '/login',
      '/cadastrar-senha'
    ]

    let existe = false
    rotas.forEach(x => {
      var reg = new RegExp(x, "g");
      if (url && reg.test(url)) {
        existe = true;
        return;
      }
    })
    return existe;
  }

}
